import publishConfigurationPanel from './config/publishConfigurationPanel';
import publishSuccessPanel from './publishSuccessPanel';
import publishRCSuccessPanel from './publishRCSuccessPanel';
import publishRCPreparePanel from './publishRCPreparePanel';
import shoutoutPanel from './content/shoutoutPanel';
import fourthPublishSuccessPanel from './fourthPublishSuccessPanel/fourthPublishSuccessPanel';
import publishErrorPanel from './publishErrorPanel/PublishErrorPanel';
import customTemplatePublishSuccessPanel from './customTemplate/successPanel/customTemplatePublishSuccessPanel';
import customTemplateFirstPublishSuccessPanel from './customTemplate/firstPublishSuccessPanel/customTemplateFirstPublishSuccessPanel';

const config = {
  publishConfigurationPanel,
};

export {
  config,
  publishSuccessPanel,
  publishErrorPanel,
  publishRCSuccessPanel,
  fourthPublishSuccessPanel,
  shoutoutPanel as shoutOut,
  publishRCPreparePanel,
  customTemplatePublishSuccessPanel,
  customTemplateFirstPublishSuccessPanel,
};
